import { TaskGroupBy } from '@jms/model';

export enum TaskMode {
    Full = 'Full',
    EvidenceUpload = 'EvidenceUpload',
    EvidenceLink = 'EvidenceLink',
}